import {
  accessibleRoutePrefixesOnboarding,
  InvestmentsRoutesEnum
} from 'investments/common/enums'
import BlackBird from 'shared/blackbird'

export function redirectNotAvailable(
  journey: string,
  pathname: string
): boolean {
  if (
    journey === 'not_available' &&
    !pathname.includes(InvestmentsRoutesEnum.NOT_AVAILABLE)
  ) {
    BlackBird.travelTo({ pathname: InvestmentsRoutesEnum.NOT_AVAILABLE })
    return true
  }

  return false
}

export function redirectOnboarding(
  needsOnboarding: boolean,
  pathname: string
): boolean {
  if (
    needsOnboarding &&
    !accessibleRoutePrefixesOnboarding.some(prefix => pathname.includes(prefix))
  ) {
    BlackBird.travelTo({ pathname: InvestmentsRoutesEnum.ONBOARDING })
    return true
  }

  if (!needsOnboarding && pathname.includes(InvestmentsRoutesEnum.ONBOARDING)) {
    BlackBird.travelTo({ pathname: InvestmentsRoutesEnum.HOME })
    return true
  }

  return false
}
